import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DifferenceScaleComponent } from './difference-scale/difference-scale.component';
import { TranslocoModule } from '@jsverse/transloco';
import { IconComponent } from '@frontend/shared';



@NgModule({
  declarations: [
    DifferenceScaleComponent
  ],
  exports: [
    DifferenceScaleComponent
  ],
  imports: [
    CommonModule,
    TranslocoModule,
    IconComponent,
  ]
})
export class DifferencesModule { }
